<template>
  <div class="table-container">
    <div class="table-item" v-for="item in content.content" :key="item.key"
    
      :style="{
        minHeight: (item.height + 'rem') || '',
      }"
    >
      <div class="table-label">{{ item.title }}</div>
      <div class="table-input-box" :class="content.content.length === 1 ? 'table-input-box-single' : ''">
        <div
          v-if="item.type === 'input'"
          :ref="'input' + item.key"
          class="table-input"
          contenteditable
          @input="inputHandle(item)"
          @blur="inputHandle(item)"
        >
        </div>
        <el-upload
          v-if="item.type === 'upload'"
          :ref="`upload${item.key}`"
          action=""
          :show-file-list="false"
          :on-change="handleChange"
          :auto-upload="false"
          multiple>
          <div slot="trigger" @click.stop="uploadHandle(item.key)" class="table-upload">点击上传</div>
        </el-upload>
      </div>
    </div>
  </div>
</template>

<script>
/*
表格组件
*/
export default {
  name: "tableEditEn",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  mounted() {
    
  },
  methods: {
    cellClickHandle(row, column, cell, event) {
      let refName = column.property + row.number;
      this.$refs[refName] && this.$refs[refName][0].focus();
    },
    inputHandle(item){
      let refName = 'input' + item.key;
      let textValue = this.$refs[refName][0].innerText;

      // let tableIndex = this.tableData.findIndex(table => table.number == item.number)
      // this.$set(this.tableData[tableIndex], prop, textValue);
    },
    handleChange(e) {
      setTimeout(() => {
        this.$message.success('上传成功！')
      }, 500)
    },
    uploadHandle(uploadKey) {
      if(this.device.isMobile && this.device.isApp && !this.device.isIos) {
          window.Android.clearChooseFile(function(res) {
            console.log(res)
            // this.uploadClick(uploadKey)
          });
          // console.log(clearFile)
          setTimeout(() => {
            this.uploadClick(uploadKey)
          }, 500)
      }else{
        this.uploadClick(uploadKey)
      }
    },
    // 手动触发点击事件
    uploadClick(uploadKey) {
      const uploadComponent = this.$refs[`upload${uploadKey}`][0];
      const inputElement = uploadComponent.$el.querySelector('input[type="file"]');
      // 手动触发点击事件
      if (inputElement) {
        inputElement.click();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.table-container{
  border: 1rem solid #5CA683;
  border-radius: 10rem;
  width: 700rem;
  margin: 20rem auto 30rem;
  overflow: hidden;
  .table-item{
    display: flex;
    min-height: 90rem;

    .table-label{
      width: 220rem;
      flex: 0 0 220rem;
      background: #5CA683;
      color: #fff;
      font-size: 26rem;
      font-family: Calibri;
      line-height: 32rem;
      font-style: italic;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      border-bottom: 1rem solid #7FBA9E;
    }

    .table-input-box{
      flex: 1;
      background: #D2E3D9;
      display: flex;
      align-items: center;
      overflow: hidden;

      .table-input{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 26rem;
        color: #333;
        padding: 16rem 10rem;
        word-break: break-word;
      }

      .table-upload{
        font-size: 24rem;
        color: #fff;
        line-height: 48rem;
        border-radius: 6rem;
        background: #8CB894;
        padding: 0 16rem;
        margin-left: 30rem;
        cursor: pointer;
      }
    }

    &:nth-child(2n){
      .table-input-box{
        background: #FFFFFF;
      }
    }

    &:last-child{
      .table-label{
        border: 0;
      }
    }

    .table-input-box-single{
      background: #FFFFFF;
    }
  }
}
</style>